var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69059 3.19847H7.80271V4.31121C7.80271 4.61721 8.05294 4.86758 8.35877 4.86758C8.6646 4.86758 8.91483 4.61721 8.91483 4.31121V3.19847H10.0269C10.3328 3.19847 10.583 2.94811 10.583 2.6421C10.583 2.3361 10.3328 2.08573 10.0269 2.08573H8.91483V0.972995C8.91483 0.666992 8.6646 0.416626 8.35877 0.416626C8.05294 0.416626 7.80271 0.666992 7.80271 0.972995V2.08573H6.69059C6.38476 2.08573 6.13453 2.3361 6.13453 2.6421C6.13453 2.94811 6.38476 3.19847 6.69059 3.19847ZM9.58766 7.24328L8.17527 7.08193C8.00919 7.06241 7.84086 7.08081 7.68291 7.13574C7.52496 7.19066 7.38151 7.28069 7.26333 7.39906L6.24018 8.42278C4.66163 7.6195 3.37857 6.33573 2.57575 4.75631L3.60446 3.72702C3.84356 3.48778 3.96033 3.1484 3.92141 2.81458L3.76015 1.41253C3.73012 1.14101 3.60132 0.89004 3.39829 0.707412C3.19525 0.524784 2.93217 0.423264 2.65915 0.42219H1.69717C1.06882 0.42219 0.546126 0.945177 0.58505 1.57387C0.879762 6.32527 4.67765 10.1197 9.42084 10.4146C10.0492 10.4535 10.5719 9.93054 10.5719 9.30184V8.33932C10.5774 7.78296 10.1493 7.30448 9.58766 7.24328Z",
    fill: "#FFBE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContact);
export default __webpack_public_path__ + "static/media/add-contact.94e7c2acd7eddf7c91f577c966e01403.svg";
export { ForwardRef as ReactComponent };